import type { FetchItemSummariesByCatalogIdQuery } from '@/redux/modules/item/summary/itemSummary.api';

import { PaginationFilter } from '@/types/PaginationFilter';
import { SearchSortAndDirection } from '@/types/search/enums/sortTypes';
import { FilterAction } from '@/types/SearchFacet';

export type CatalogItemsSlice = {
    byId: { [catalogId: number]: number[] };
    loaded: number;
    loading: boolean;
    pagination: PaginationFilter &
        FetchItemSummariesByCatalogIdQuery & {
            results: number;
            totalRecords: number;
        };
};

export const defaultCatalogItemsSlice: CatalogItemsSlice = {
    byId: {},
    loaded: 0,
    loading: false,
    pagination: {
        keyword: '',
        page: 1,
        pageSize: 24,
        results: 0,
        sort: SearchSortAndDirection.LotNumberLowest,
        totalRecords: 0,
    },
};

export type FetchCatalogItemsParams = {
    catalogId: number;
    /** The filter action that triggered this fetch, used for Search Refined analytics tracking */
    filterAction?: FilterAction;
    query: FetchItemSummariesByCatalogIdQuery;
};
